<div class="modal-header">
  <div class="modal-title-wrapper">
    <h2 class="modal-title fw-bold">{{ eventService.event_service_name }}</h2>
    <div class="service-meta d-flex gap-4 mt-2">
      @if (eventService.price) {
        <span class="text-muted">
          <i class="fa fa-money-bill me-2"></i>
          {{ eventService.price }} {{ eventService.price_currency }}
        </span>
      }
      <span class="text-muted">
        <i class="fa fa-users me-2"></i>
        {{ getTotalRegistrations() }} {{ getTotalRegistrations() !== 1 ? ('manageEvent.viewServiceRegistrations.registrationsPlural' | translate) : ('manageEvent.viewServiceRegistrations.registrationSingular' | translate) }}
      </span>
    </div>
  </div>
  <button type="button" class="btn-close" (click)="close()"></button>
</div>

<div class="modal-body">
  @if (eventService.event_service_description) {
    <div class="alert alert-info d-flex align-items-center mb-6">
      <i class="fa fa-info-circle fs-2x me-3"></i>
      <div>{{ eventService.event_service_description }}</div>
    </div>
  }

  @if (eventService.event_service_registrations.length === 0) {
    <div class="text-center py-10">
      <i class="fa fa-users-slash fs-3x text-muted mb-5"></i>
      <h4 class="text-muted">{{ 'manageEvent.viewServiceRegistrations.noRegistrationsTitle' | translate }}</h4>
      <p class="text-muted">{{ 'manageEvent.viewServiceRegistrations.noRegistrationsText' | translate }}</p>
    </div>
  } @else {
    <!-- Registrations Table -->
    <div class="table-responsive">
      <table class="table table-row-bordered table-row-dashed gy-4 align-middle fw-bold">
        <thead class="fw-bold text-muted bg-light">
          <tr>
            <th class="ps-6">#</th>
            <th>{{ 'manageEvent.viewServiceRegistrations.user' | translate }}</th>
            <th>{{ 'manageEvent.viewServiceRegistrations.quantity' | translate }}</th>
            <th>{{ 'manageEvent.viewServiceRegistrations.orderNumber' | translate }}</th>
            <th>{{ 'manageEvent.viewServiceRegistrations.payment' | translate }}</th>
            <th>{{ 'manageEvent.viewServiceRegistrations.registeredOn' | translate }}</th>
            <th>{{ 'manageEvent.viewRegistrations.notes' | translate }}</th>
            <th class="text-end">{{ 'manageEvent.viewServiceRegistrations.actions' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          @for (registration of eventService.event_service_registrations; track registration.event_service_registration_id; let i = $index) {
            <tr>
              <td class="ps-6 fw-semibold text-gray-700">{{ getRegistrationNumber(i) }}</td>
              <td>
                @if (registration.user) {
                  <div
                    class="d-flex flex-column cursor-pointer user-info-hover"
                    [ngbTooltip]="userTooltip"
                    placement="right"
                    container="body">
                    <span class="fw-semibold text-gray-800">
                      {{ registration.user.first_name }} {{ registration.user.last_name }}
                    </span>
                    @if (registration.user.email) {
                      <span class="text-muted fs-7">{{ registration.user.email }}</span>
                    }
                  </div>
                  <ng-template #userTooltip>
                    <div class="tooltip-content">
                      <div class="tooltip-header">{{ 'manageEvent.viewServiceRegistrations.userInfo' | translate }}</div>
                      <div class="tooltip-row">
                        <strong>{{ 'manageEvent.viewServiceRegistrations.name' | translate }}:</strong> {{ registration.user.first_name }} {{ registration.user.last_name }}
                      </div>
                      @if (registration.user.email) {
                        <div class="tooltip-row">
                          <strong>{{ 'manageEvent.viewServiceRegistrations.email' | translate }}:</strong> {{ registration.user.email }}
                        </div>
                      }
                      @if (registration.user.phone) {
                        <div class="tooltip-row">
                          <strong>{{ 'manageEvent.viewServiceRegistrations.phone' | translate }}:</strong> {{ registration.user.phone }}
                        </div>
                      }
                      @if (registration.user.date_of_birth) {
                        <div class="tooltip-row">
                          <strong>{{ 'manageEvent.viewServiceRegistrations.dateOfBirth' | translate }}:</strong> {{ formatDateDMYDots(registration.user.date_of_birth) }}
                        </div>
                      }
                      @if (registration.user.city || registration.user.country) {
                        <div class="tooltip-row">
                          <strong>{{ 'manageEvent.viewServiceRegistrations.location' | translate }}:</strong> {{ registration.user.city }}@if(registration.user.city && registration.user.country){, }{{ registration.user.country }}
                        </div>
                      }
                    </div>
                  </ng-template>
                } @else {
                  <span class="text-muted">N/A</span>
                }
              </td>
              <td>
                <span class="badge badge-light-primary">{{ registration.num_registrations }}</span>
              </td>
              <td>
                @if (registration.order_id) {
                  <span class="fw-semibold text-gray-700">#{{ registration.order_id }}</span>
                } @else {
                  <span class="text-muted">-</span>
                }
              </td>
              <td>
                @if (registration.payment_status === 'paid') {
                  <span class="badge badge-light-success">{{ 'manageEvent.viewServiceRegistrations.paymentPaid' | translate }}</span>
                } @else if (registration.payment_status === 'pending' || registration.payment_status === 'pay_later') {
                  <span class="badge badge-light-warning">{{ 'manageEvent.viewServiceRegistrations.paymentPending' | translate }}</span>
                } @else if (registration.payment_status === 'refunded') {
                  <span class="badge badge-light-danger">{{ 'manageEvent.viewServiceRegistrations.paymentRefunded' | translate }}</span>
                } @else {
                  <span class="badge badge-light-secondary">{{ 'manageEvent.viewServiceRegistrations.paymentNotRequired' | translate }}</span>
                }
              </td>
              <td>
                @if (registration.created_at) {
                  <span class="text-gray-700">{{ formatDateDMYDots(registration.created_at) }}</span>
                } @else {
                  <span class="text-muted">-</span>
                }
              </td>
              <td>
                @if (registration.notes) {
                  <div
                    class="notes-indicator d-inline-flex align-items-center gap-2 cursor-pointer"
                    [ngbTooltip]="notesTooltip"
                    tooltipClass="notes-tooltip"
                    placement="top"
                    container="body"
                  >
                    <i class="fa fa-comment-dots text-primary"></i>
                    <span class="notes-preview text-muted fs-7">{{ registration.notes.length > 20 ? (registration.notes.slice(0, 20) + '...') : registration.notes }}</span>
                  </div>
                  <ng-template #notesTooltip>
                    <div class="notes-tooltip-content">
                      <div class="notes-tooltip-header">
                        <i class="fa fa-comment-dots me-2"></i>
                        {{ 'manageEvent.viewRegistrations.participantNotes' | translate }}
                      </div>
                      <div class="notes-tooltip-body">{{ registration.notes }}</div>
                    </div>
                  </ng-template>
                } @else {
                  <span class="text-muted">-</span>
                }
              </td>
              <td class="text-end">
                <div class="dropdown">
                  <button
                    class="btn btn-sm btn-icon btn-light btn-active-light-primary"
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <i class="fa fa-ellipsis-v"></i>
                  </button>
                  <ul class="dropdown-menu dropdown-menu-end">
                    @if (registration.payment_status === 'pending' || registration.payment_status === 'pay_later') {
                      <li class="dropdown-header">{{ 'manageEvent.viewServiceRegistrations.markAsPaid' | translate }}</li>
                      @if (hasCustomPayment && customPaymentMethodName) {
                        <li>
                          <a class="dropdown-item" (click)="markAsPaid(registration, 'bank_transfer')">
                            <i class="fa fa-hand-holding-dollar me-2"></i>
                            {{ customPaymentMethodName }}
                          </a>
                        </li>
                      } @else {
                        <li>
                          <a class="dropdown-item" (click)="markAsPaid(registration, 'bank_transfer')">
                            <i class="fa fa-university me-2"></i>
                            {{ 'manageEvent.viewServiceRegistrations.paymentBankTransfer' | translate }}
                          </a>
                        </li>
                        <li>
                          <a class="dropdown-item" (click)="markAsPaid(registration, 'cash')">
                            <i class="fa fa-money-bill me-2"></i>
                            {{ 'manageEvent.viewServiceRegistrations.paymentCash' | translate }}
                          </a>
                        </li>
                        <li>
                          <a class="dropdown-item" (click)="markAsPaid(registration, 'other')">
                            <i class="fa fa-credit-card me-2"></i>
                            {{ 'manageEvent.viewServiceRegistrations.paymentOther' | translate }}
                          </a>
                        </li>
                      }
                      <li><hr class="dropdown-divider"></li>
                    }
                    <li>
                      <a class="dropdown-item" (click)="openEditRegistrationModal(registration)">
                        <i class="far fa-edit me-2"></i>
                        {{ 'manageEvent.viewServiceRegistrations.editRegistration' | translate }}
                      </a>
                    </li>
                    <li><hr class="dropdown-divider"></li>
                    <li>
                      <a class="dropdown-item text-danger" (click)="deleteRegistration(registration)">
                        <i class="far fa-trash-can me-2"></i>
                        {{ 'manageEvent.viewServiceRegistrations.cancelRegistration' | translate }}
                      </a>
                    </li>
                  </ul>
                </div>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>

    <!-- Summary Section -->
    <div class="separator my-6"></div>

    <div class="row g-5">
      <div class="col-md-4">
        <div class="card bg-light-primary">
          <div class="card-body p-5">
            <div class="d-flex align-items-center">
              <i class="fa fa-users fs-2x text-primary me-4"></i>
              <div>
                <div class="fs-7 text-muted">{{ 'manageEvent.viewServiceRegistrations.totalRegistrations' | translate }}</div>
                <div class="fs-2 fw-bold text-gray-800">{{ getTotalRegistrations() }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      @if (eventService.max_num_registrations) {
        <div class="col-md-4">
          <div class="card bg-light-warning">
            <div class="card-body p-5">
              <div class="d-flex align-items-center">
                <i class="fa fa-chart-line fs-2x text-warning me-4"></i>
                <div>
                  <div class="fs-7 text-muted">{{ 'manageEvent.viewServiceRegistrations.capacity' | translate }}</div>
                  <div class="fs-2 fw-bold text-gray-800">
                    {{ getTotalRegistrations() }} / {{ eventService.max_num_registrations }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      }

      @if (eventService.price) {
        <div class="col-md-4">
          <div class="card bg-light-success">
            <div class="card-body p-5">
              <div class="d-flex align-items-center">
                <i class="fa fa-money-bill fs-2x text-success me-4"></i>
                <div>
                  <div class="fs-7 text-muted">{{ 'manageEvent.viewServiceRegistrations.totalRevenue' | translate }}</div>
                  <div class="fs-2 fw-bold text-gray-800">
                    {{ getNetRevenue() | number:'1.0-0' }} {{ eventService.price_currency }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  }
</div>

<div class="modal-footer">
  <app-button
    [variant]="'outline'"
    [label]="'common.close' | translate"
    (clicked)="close()"
  />
  <app-button
    [variant]="'primary'"
    [label]="'manageEvent.viewServiceRegistrations.addRegistration' | translate"
    [iconClass]="'fa fa-user-plus'"
    (clicked)="openAddRegistrationModal()"
  />
</div>
